import script from "./SparkleIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SparkleIcon.vue?vue&type=script&setup=true&lang=js"

import "./SparkleIcon.vue?vue&type=style&index=0&id=7aeec3f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aeec3f9"]])

export default __exports__